const comments = [
  {
    name: '追剧小能手',
    text: '用了97影院半年了，真的良心！更新速度和电视台同步，画质也超清。之前用别的平台老是卡，这边流畅得飞起，国产剧韩剧全都有，必须安利给身边所有追剧的朋友！',
    show: '《长安如故》',
    time: '2小时前',
  },
  {
    name: '深夜剧迷',
    text: '终于找到一个没有广告的看剧平台了！之前看个剧弹窗烦死人。97影院的蓝光画质真的绝，而且美剧资源特别全，连冷门高分剧都能找到，太惊喜了。',
    show: '《风骚律师》',
    time: '5小时前',
  },
  {
    name: '韩剧控小王',
    text: '韩剧爱好者狂喜！从经典老剧到最新热播全都有，而且中文字幕很及时。追完《财阀家的小儿子》又发现了《与恶魔有约》，宝藏平台实锤了！',
    show: '《财阀家的小儿子》',
    time: '1天前',
  },
  {
    name: '古装剧资深粉',
    text: '作为一个古装剧迷，97影院简直是我的天堂。从《琅琊榜》到最新的《大奉打更人》，分类清晰找剧方便。画质清晰度真的吊打很多平台，强烈推荐！',
    show: '《大奉打更人》',
    time: '1天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            观众口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来看看追剧同好们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto">
          {comments.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">
                    正在看 <span className="text-primary-500">{item.show}</span>
                  </div>
                </div>
                <div className="ml-auto text-xs text-foreground-400">{item.time}</div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/50">
                <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line mr-1"></i>有用
                </span>
                <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}